import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { designSystemPageMeta, designSystemSchema } from 'components/common/schema'
import Template from 'components/services/design-system'

const Design_system: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...designSystemPageMeta} />
      <JsonLd data={designSystemSchema} />
      <Template />
    </>
  )
}

export default Design_system
